import { Query, SortDirection, TableHeader } from "../interfaces";

export default function useSortProperties(
  appState: Query,
  updateSort: (sortField: string, sortDirection: SortDirection) => void,
) {
  function sortHandler(tableHeader: TableHeader) {
    if (tableHeader.apiField && appState.sort) {
      const sortDirection =
        appState.sort.sortField === tableHeader.apiField &&
        appState.sort.sortOrder === "ASC"
          ? "DESC"
          : "ASC";
      updateSort(tableHeader.apiField, sortDirection);
    }
  }

  return {
    sortHandler,
    sortField: appState.sort ? appState.sort.sortField : "",
    sortDirection: appState.sort ? appState.sort.sortOrder : "ASC",
  };
}
